import React, { useEffect, useRef } from 'react';

// コンポーネントのインポート
import ApiKeyModal from './components/ApiKeyModal';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import ChatArea from './components/ChatArea';
import InputArea from './components/InputArea';

// カスタムフックのインポート
import { useConversations } from './hooks/useConversations';
import { useApiKey } from './hooks/useApiKey';
import { useChat } from './hooks/useChat';

function App() {
  const messagesEndRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  // カスタムフックを使用して状態とロジックを管理
  const {
    conversations,
    currentConversation,
    currentConversationId,
    setCurrentConversationId,
    createNewConversation,
    deleteConversation,
    addMessageToConversation,
    updateConversationSummary,
    editMessageInConversation,
    rollbackToMessage: rollbackToMessageInConversation
  } = useConversations();

  const {
    apiKey,
    tempApiKey,
    setTempApiKey,
    showApiKeyModal,
    setShowApiKeyModal,
    apiError,
    setApiError,
    saveApiKey,
    openApiKeyModal
  } = useApiKey();

  const {
    inputMessage,
    setInputMessage,
    isLoading,
    editingMessageId,
    editingContent,
    setEditingContent,
    copiedMessageId,
    sendMessage,
    stopGeneration,
    copyMessage,
    startEditMessage,
    cancelEditMessage,
    editMessage
  } = useChat({
    currentConversationId,
    currentConversation,
    apiKey,
    addMessageToConversation,
    updateConversationSummary,
    editMessageInConversation,
    setApiError,
    openApiKeyModal
  });

  // メッセージリストの最下部にスクロール
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [conversations, currentConversationId]);

  // 指定したメッセージまでロールバック
  const rollbackToMessage = React.useCallback((messageId) => {
    rollbackToMessageInConversation(currentConversationId, messageId);
  }, [currentConversationId, rollbackToMessageInConversation]);

  return (
    <div className="app-container">
      {/* APIキー入力モーダル */}
      <ApiKeyModal
        showApiKeyModal={showApiKeyModal}
        tempApiKey={tempApiKey}
        setTempApiKey={setTempApiKey}
        saveApiKey={saveApiKey}
        setShowApiKeyModal={setShowApiKeyModal}
        apiKey={apiKey}
        apiError={apiError}
      />

      {/* サイドバー */}
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        conversations={conversations}
        currentConversationId={currentConversationId}
        createNewConversation={createNewConversation}
        openApiKeyModal={openApiKeyModal}
        setCurrentConversationId={setCurrentConversationId}
        setIsSidebarOpen={setIsSidebarOpen}
        deleteConversation={deleteConversation}
      />

      {/* メインコンテンツ */}
      <div className="main-content">
        {/* ヘッダー */}
        <Header
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          apiKey={apiKey}
        />

        {/* チャットエリア */}
        <ChatArea
          currentConversation={currentConversation}
          editingMessageId={editingMessageId}
          editingContent={editingContent}
          setEditingContent={setEditingContent}
          editMessage={editMessage}
          cancelEditMessage={cancelEditMessage}
          isLoading={isLoading}
          startEditMessage={startEditMessage}
          rollbackToMessage={rollbackToMessage}
          copyMessage={copyMessage}
          copiedMessageId={copiedMessageId}
          apiError={apiError}
          showApiKeyModal={showApiKeyModal}
          openApiKeyModal={openApiKeyModal}
          messagesEndRef={messagesEndRef}
        />

        {/* 入力エリア */}
        <InputArea
          apiKey={apiKey}
          currentConversationId={currentConversationId}
          inputMessage={inputMessage}
          setInputMessage={setInputMessage}
          isLoading={isLoading}
          sendMessage={sendMessage}
          stopGeneration={stopGeneration}
          openApiKeyModal={openApiKeyModal}
        />
      </div>
    </div>
  );
}

export default App;